import { combineReducers } from "redux";

import common from "./common/common.reducer";

export default combineReducers({
  common
});
